// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input_text-module__input--3RsX4{font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px;margin-right:8px;border-color:#e7ebef;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;height:40px}.input_text-module__input--3RsX4:focus{border:1px solid #36b}\n", ""]);
// Exports
exports.locals = {
	"input": "input_text-module__input--3RsX4"
};
module.exports = exports;
